import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-denuncia-view',
  templateUrl: 'denuncia-view.html',
})
export class DenunciaViewPage {

  denuncia :any = { };

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.denuncia = this.navParams.get('denuncia');
  }

}



// WEBPACK FOOTER //
// ./src/pages/denuncia/denuncia-view/denuncia-view.ts